module.exports = __webpack_public_path__ + "static/chains-fa8e02ac91aea4d74d6b0805376f7819.png";